import { createReducer, on } from "@ngrx/store";
import * as DoctorActions from "./doctor.actions";
import { initialDoctorState } from "./doctor.state";

export const DoctorReducer = createReducer(
  initialDoctorState,

  // Load All
  on(DoctorActions.loadDoctors, (state) => ({
    ...state,
    loading: true,
  })),
  on(DoctorActions.loadDoctorsSuccess, (state, { doctors }) => ({
    ...state,
    doctors,
    loading: false,
  })),
  on(DoctorActions.loadDoctorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load One
  on(DoctorActions.loadDoctorSuccess, (state, { doctor }) => ({
    ...state,
    selectedDoctor: doctor,
  })),

  // Create
  on(DoctorActions.createDoctorSuccess, (state, { doctor }) => ({
    ...state,
    doctors: [...state.doctors, doctor],
  })),

  // Update
  on(DoctorActions.updateDoctorSuccess, (state, { doctor }) => ({
    ...state,
    doctors: state.doctors.map((d) => (d.id === doctor.id ? doctor : d)),
  })),

  // Delete
  on(DoctorActions.deleteDoctorSuccess, (state, { id }) => ({
    ...state,
    doctors: state.doctors.filter((d) => d.id !== id),
  })),

  // Duplicate Checks
  on(DoctorActions.checkDoctorAltCodeDuplicateSuccess, (state, { exists }) => ({
    ...state,
    altCodeExists: exists,
  })),
  on(DoctorActions.checkDoctorRegistrationDuplicateSuccess, (state, { exists }) => ({
    ...state,
    registrationNumberExists: exists,
  })),

  // 🔍 Search
  on(DoctorActions.searchDoctors, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DoctorActions.searchDoctorsSuccess, (state, { doctors, total, rowIndex }) => ({
    ...state,
    loading: false,
    searchResultsByRow: {
      ...state.searchResultsByRow,
      [rowIndex]: doctors,
    },
    total,
  })),
  on(DoctorActions.searchDoctorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(DoctorActions.clearSearchDoctors, (state) => ({
    ...state,
    searchResultsByRow: {},
    total: 0,
  })),

  // ✅ Selected Doctor
  on(DoctorActions.setSelectedDoctor, (state, { doctor }) => ({
    ...state,
    selectedDoctor: doctor,
  }))
);
